// Meta Pixel event helper.
// Safe-fires fbq('track', 'Lead', { content_name }) on CTA clicks.
// Never throws if fbq isn't loaded (e.g. ad-block, slow network).
export const trackLead = (contentName) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Lead", {
        content_name: contentName,
        content_category: "telegram_cta",
      });
    }
  } catch (_) {
    /* swallow — analytics must never break UX */
  }
};
